import { OfficialReportType } from '@/types/officialReport'

export const OFFICIAL_REPORT_FORM_FIELDS = {
    dateOfIssue: 'dateOfIssue',
    timeOfIssue: 'timeOfIssue',
    timeType: 'timeType',
    takeoverTime: 'takeoverTime',
    actualTakeoverTime: 'actualTakeoverTime',
    driverEmployeeNumber: 'driverEmployeeNumber',
    locationOfIssue: 'locationOfIssue',
    details: 'details',
    driverStatement: 'driverStatement',
    headways: 'headways',
} as const

export const LATE_TAKEOVER_DETAILS_TAGS = {
    location: '<span>Location</span>',
    takeoverTime: '<span>Takeover time</span>',
    takeoverTimeDifference: '<span>Incident time - Takeover time</span>',
    actualTakeoverTime: '<span>Actual takeover time</span>',
    departureTime: '<span>Departure time</span>',
    timeType: '<span>given/scheduled</span>',
}

export const HEADWAY_DETAILS_TAGS = {
    location: '<span>Location</span>',
    headways: '<div class="headways"></div>',
}

export const DRAFT_ERROR_FIELDS = [
    OFFICIAL_REPORT_FORM_FIELDS.actualTakeoverTime,
    OFFICIAL_REPORT_FORM_FIELDS.dateOfIssue,
    OFFICIAL_REPORT_FORM_FIELDS.takeoverTime,
    OFFICIAL_REPORT_FORM_FIELDS.timeOfIssue,
    OFFICIAL_REPORT_FORM_FIELDS.headways,
]

export const OFFICIAL_REPORT_TYPE_MAP: Record<string, string> = {
    [OfficialReportType.Headway]: 'Headway',
    [OfficialReportType.LateDeparture]: 'Late departure ',
    [OfficialReportType.LateTakeover]: 'Late takeover',
}
